import { render, staticRenderFns } from "./DocumentEmailModal.vue?vue&type=template&id=7670f6dc&scoped=true&"
import script from "./DocumentEmailModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentEmailModal.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEmailModal.vue?vue&type=style&index=0&id=7670f6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670f6dc",
  null
  
)

export default component.exports